export default __webpack_public_path__ + "static/media/CC_FontSize_icon.bb6bdfe9.svg";